import { render, staticRenderFns } from "./ResultsLeaderboard.vue?vue&type=template&id=e348670e"
import script from "./ResultsLeaderboard.vue?vue&type=script&lang=js"
export * from "./ResultsLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./ResultsLeaderboard.vue?vue&type=style&index=0&id=e348670e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports